<template>
    <div>
        <nav class="paginations">
            <ul class="pagination mt-2">
                <li v-for="(link, key) in links" :key="key" :class="getClass(link)">
                    <a class="page-link" @click.prevent="navigation(link)">{{
                        link.label
                    }}</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        props: {
            links: Array,
            navigationFunction: Function
        },
        methods: {
            getClass(item) {
                if (item.url === null) return "page-item disabled no-cursor";
                if (item.url != null) {
                    if (item.active === true) {
                        return "page-item active no-cursor";
                    }else return "page-item";
                }
            },
            navigation(nav) {
                const url = nav.url.split("=");
                const page = url[1];
                this.navigationFunction(url[1]);
            },
        }
    }
</script>

<style lang="scss">
.paginations {

    display: grid;
    grid-template-columns: 1fr;
    justify-content: end;
    align-items: center;
    justify-items: end;
}
.no-cursor {
    cursor: default !important;
    pointer-events: none;
}
</style>